import { render, staticRenderFns } from "./LinearRegression.vue?vue&type=template&id=c54ae19c&scoped=true&"
import script from "./LinearRegression.vue?vue&type=script&lang=js&"
export * from "./LinearRegression.vue?vue&type=script&lang=js&"
import style0 from "./LinearRegression.vue?vue&type=style&index=0&id=c54ae19c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54ae19c",
  null
  
)

export default component.exports